import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { CommonComponentsModule } from '../../common-components/common-components.module';
import { PartyModule } from '../../party/party.module';
import { AccountsRoutingModule } from './accounts-routing.module';
import { CreateAccountsComponent } from './create-accounts/create-accounts.component';
import { FeaturesComponent } from './features/features.component';
import { GlobalAdminComponent } from './global-admin/global-admin.component';
import { LoginAuditsComponent } from './login-audits/login-audits.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { RolesComponent } from './roles/roles.component';
import { EditAccountComponent } from './search-accounts/edit-account/edit-account.component';
import { SearchAccountsComponent } from './search-accounts/search-accounts.component';
import { ViewAccountComponent } from './search-accounts/view-account/view-account.component';
import { ViewUserWorkAddressesComponent } from './search-accounts/view-user-work-addresses/view-user-work-addresses.component';

@NgModule({
    declarations: [
        SearchAccountsComponent,
        CreateAccountsComponent,
        LoginAuditsComponent,
        RolesComponent,
        FeaturesComponent,
        PermissionsComponent,
        GlobalAdminComponent,
        ViewAccountComponent,
        ViewUserWorkAddressesComponent,
        EditAccountComponent
    ],
    imports: [
        CommonModule,
        CommonComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        PipesModule,
        AccountsRoutingModule,
        PartyModule
    ]
})
export class AccountsModule {}
